import { render, staticRenderFns } from "./VariableIncomeAcquisition.vue?vue&type=template&id=4323e10a&scoped=true"
import script from "./VariableIncomeAcquisition.vue?vue&type=script&lang=ts&setup=true"
export * from "./VariableIncomeAcquisition.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./VariableIncomeAcquisition.vue?vue&type=style&index=0&id=4323e10a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4323e10a",
  null
  
)

export default component.exports